

















































































































import { Component, Vue, Provide, Watch, Mixins } from 'vue-property-decorator';
import { Bot } from '@/dtos/bot';
import { Getter } from 'vuex-class';
import { PairConfig } from '@/dtos/PairConfig';
import { removeBot, botStartStop } from '@/apis/bot.api';
import { setInterval, clearInterval } from 'timers';
import { getServerTimestamp } from '@/apis/authorize.api';
import { BotInstance } from '@/dtos/Instance';
import { runInterval, mounted } from '@/services/VueTimmer';
import _ from 'lodash';
import BotMixins from '@/mixins/botsMixins';
import TableGroup from '@/components/shared/TableGroup';
import GroupSelects from '@/components/shared/GroupSelects.vue';
import { SyncWithRouterQuerySimple } from '@/services/SyncWithRoute';

@Component({
  components: {
    TableGroup,
    GroupSelects,
  },
})
export default class ManagementBotPage extends Mixins(BotMixins) {
  @SyncWithRouterQuerySimple('groups', {
    defaultValue: ['market',''],
    validate: e => e instanceof Array && e.every(e => typeof e == 'string'),
  })
  groupByFields!: string[];

  @SyncWithRouterQuerySimple('search')
  search: string;

  stringify(value) {
    return this.$options.filters.stringify(value);
  }
}
